import React, { useCallback, useEffect, useState } from 'react'
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom'
import { routeName } from '../../../../routes/routeName'
import { Grid, MenuItem, Typography } from '@mui/material'
import FormComponent from '../../../../components/gernerateForm/FormComponent'
import RadioCustom from '../../../../components/radio/RadioCustom'
import CheckBoxCustom from '../../../../components/checkbox/CheckBoxCustom'
import FilterSelect from '../../../../components/select/filterSelect'
import { ButtonBack, ButtonOutlined, ButtonPrimary } from '../../../../components/button/ButtonCustoms'
import TableCustom from '../../../../components/table/tableCustom'
import TableRowCommon from '../../../../components/table/TableRowCommon'
import { RemoveRedEyeOutlined, SearchOutlined } from '@mui/icons-material'
import SwitchCustom from '../../../../components/switch/SwitchCustom'
import InputTextField from '../../../../components/input/inputTextField'
import { MeetingPositionApi } from '../../../../api/meeting-position/meeting-position.api'
import { EmployeeApi } from '../../../../api/employee/employee.api'
import _, { assign } from 'lodash'
import { MeetingRoomApi } from '../../../../api/meeting-room/meeting-room.api'
import { swalError, swalSuccess } from '../../../../components/alert/swal'
import { NavigateFunction, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import UploadAvatar from '../../../../components/upload/UploadAvatar'
import ModalCustom from '../../../../components/modal/ModalCustom'
import { useTranslation } from 'react-i18next'
import { PositionApi } from '../../../../api/position/position.api'
import { OrganizationApi } from '../../../../api/organization/organization.api'

export default function AddMeetingParticipants() {
    const { t, i18n } = useTranslation();
    const generateForm = [
        {
            label: t("คำนำหน้า (ไทย)"),
            name: "leave_type_form_template",
            placeholder: t("ระบุคำนำหน้า (ไทย)"),
            type: "select",
            typeForm: "text",
            formSize: "small",
            optionName: "leave_form",
            defaultOption: "",
            style: {},
            responsive: { sm: 12, md: 6, lg: 2 },
            isRequired: false,
            titleRequired: t("กรุณาป้อนรูปแบบฟอร์ม"),
            disable: false,
            section: "section_1",
        },
        {
            label: t("ชื่อ (ไทย)"),
            name: "leave_type_name",
            placeholder: t("ระบุชื่อ (ไทย)"),
            type: "input",
            typeForm: "text",
            formSize: "small",
            optionName: "",
            defaultOption: "",
            style: {},
            responsive: { sm: 12, md: 12, lg: 4 },
            isRequired: false,
            titleRequired: t("กรุณาป้อนชื่อรูปแบบ"),
            disable: false,
            section: 'section_1',
        },
        {
            label: t("นามสกุล (ไทย)"),
            name: "leave_type_name",
            placeholder: t("ระบุนามสกุล (ไทย)"),
            type: "input",
            typeForm: "text",
            formSize: "small",
            optionName: "",
            defaultOption: "",
            style: {},
            responsive: { sm: 12, md: 12, lg: 4 },
            isRequired: false,
            titleRequired: t("กรุณาป้อนชื่อรูปแบบ"),
            disable: false,
            section: 'section_1',
        },
        {
            label: t("ฉายา/ชื่อเล่น (ไทย)"),
            name: "leave_type_name",
            placeholder: t("ระบุฉายา/ชื่อเล่น (ไทย)"),
            type: "input",
            typeForm: "text",
            formSize: "small",
            optionName: "",
            defaultOption: "",
            style: {},
            responsive: { sm: 12, md: 12, lg: 2 },
            isRequired: false,
            titleRequired: t("กรุณาป้อนชื่อรูปแบบ"),
            disable: false,
            section: 'section_1',
        },
        {
            label: t("คำนำหน้า (อังกฤษ)"),
            name: "leave_type_form_template",
            placeholder: t("ระบุคำนำหน้า (อังกฤษ)"),
            type: "select",
            typeForm: "text",
            formSize: "small",
            optionName: "leave_form",
            defaultOption: "",
            style: {},
            responsive: { sm: 12, md: 6, lg: 2 },
            isRequired: false,
            titleRequired: t("กรุณาป้อนรูปแบบฟอร์ม"),
            disable: false,
            section: "section_1",
        },
        {
            label: t("ชื่อ (อังกฤษ)"),
            name: "leave_type_name",
            placeholder: t("ระบุชื่อ (อังกฤษ)"),
            type: "input",
            typeForm: "text",
            formSize: "small",
            optionName: "",
            defaultOption: "",
            style: {},
            responsive: { sm: 12, md: 12, lg: 4 },
            isRequired: false,
            titleRequired: t("กรุณาป้อนชื่อรูปแบบ"),
            disable: false,
            section: 'section_1',
        },
        {
            label: t("นามสกุล (อังกฤษ)"),
            name: "leave_type_name",
            placeholder: t("ระบุนามสกุล (อังกฤษ)"),
            type: "input",
            typeForm: "text",
            formSize: "small",
            optionName: "",
            defaultOption: "",
            style: {},
            responsive: { sm: 12, md: 12, lg: 4 },
            isRequired: false,
            titleRequired: t("กรุณาป้อนชื่อรูปแบบ"),
            disable: false,
            section: 'section_1',
        },
        {
            label: t("ฉายา/ชื่อเล่น (อังกฤษ)"),
            name: "leave_type_name",
            placeholder: t("ระบุฉายา/ชื่อเล่น (อังกฤษ)"),
            type: "input",
            typeForm: "text",
            formSize: "small",
            optionName: "",
            defaultOption: "",
            style: {},
            responsive: { sm: 12, md: 12, lg: 2 },
            isRequired: false,
            titleRequired: t("กรุณาป้อนชื่อรูปแบบ"),
            disable: false,
            section: 'section_1',
        },
        {
            label: t("เบอร์โทร"),
            name: "leave_type_name",
            placeholder: t("เบอร์โทร"),
            type: "input",
            typeForm: "text",
            formSize: "small",
            optionName: "",
            defaultOption: "",
            style: {},
            responsive: { sm: 12, md: 12, lg: 3 },
            isRequired: false,
            titleRequired: t("กรุณาป้อนชื่อรูปแบบ"),
            disable: false,
            section: 'section_1',
        },
        {
            label: t("อีเมล"),
            name: "leave_type_name",
            placeholder: t("อีเมล"),
            type: "input",
            typeForm: "text",
            formSize: "small",
            optionName: "",
            defaultOption: "",
            style: {},
            responsive: { sm: 12, md: 12, lg: 3 },
            isRequired: false,
            titleRequired: t("กรุณาป้อนชื่อรูปแบบ"),
            disable: false,
            section: 'section_1',
        },
        {
            label: t("ตำแหน่งงานปัจจุบัน"),
            name: "leave_type_name",
            placeholder: t("ตำแหน่งงานปัจจุบัน"),
            type: "input",
            typeForm: "text",
            formSize: "small",
            optionName: "",
            defaultOption: "",
            style: {},
            responsive: { sm: 12, md: 12, lg: 3 },
            isRequired: false,
            titleRequired: t("กรุณาป้อนชื่อรูปแบบ"),
            disable: false,
            section: 'section_1',
        },
        {
            label: t("สังกัด"),
            name: "leave_type_name",
            placeholder: t("สังกัด"),
            type: "input",
            typeForm: "text",
            formSize: "small",
            optionName: "",
            defaultOption: "",
            style: {},
            responsive: { sm: 12, md: 12, lg: 3 },
            isRequired: false,
            titleRequired: t("กรุณาป้อนชื่อรูปแบบ"),
            disable: false,
            section: 'section_1',
        },

    ];
    const [step, setStep] = useState<string>('EMPLOYEE')
    const { id, id_participant } = useParams();
    const [searchParams] = useSearchParams();
    const mode = searchParams.get("mode");
    const navigate: NavigateFunction = useNavigate();
    const [open, setOpen] = useState<boolean>(false)
    const [detail, setDetail] = useState<any>()
    const [form, setForm] = useState<any>()
    const [content, setContent] = useState<any>()
    const [data, setData] = useState<any[]>([]);
    const [advisor, setAdvisor] = useState<any[]>([]);
    const [meetingPosition, setMeetingPosition] = useState<any[]>([]);
    const [file, setFile] = useState<any>();
    const [dataPosition, setDataPosition] = useState([]);

    const [dataDepartment, setDataDepartment] = useState([]);

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(5);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [search, setSearch] = useState<string>("");
    const [sortBy, setSortBy] = useState<string>("");
    const [department, setDepartment] = useState<string>("ALL");
    const [position, setPosition] = useState<string>("ALL");
    const [sortType, setSortType] = useState<string>("ASC");
    const [tab, setTab] = useState<number>(0)
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy);
        setSortType(sortType);
    };
    const [isChecks, setIsChecks] = useState<any[]>([]);
    const [isCheckAll, setIsCheckAll] = useState<string>("");

    const onCheck = (event: any) => {
        const { checked, value } = event;
        if (checked) {
            setIsChecks((prev) => [...prev, Number(value)]);
        } else {
            setIsChecks((prev) => prev.filter((x) => x !== Number(value)));
        }
    };

    const onCheckAll = (event: any) => {
        const { checked } = event;
        const id = data?.map(
            (filteredItem: { id_employee: number }) => filteredItem?.id_employee
        );
        if (checked) {
            setIsChecks(Array.from(new Set([...isChecks, ...id])));
        } else {
            setIsChecks([]);
            // setIsChecks(_.filter(isChecks, (i) => !_.includes(id, i)));
        }
    };
    const handleOnCheckAll = () => {
        const filterData = data
        const hasSome = _.some(filterData, (i: any) =>
            _.some(isChecks, (j: number) => Number(i?.id_employee) === Number(j))
        );
        const hasAll = _.every(filterData, (i: any) =>
            _.some(isChecks, (j: number) => Number(i?.id_employee) === Number(j))
        );
        if (!_.isEmpty(isChecks) && !hasAll && hasSome)
            setIsCheckAll("indeterminate");
        else if (!_.isEmpty(isChecks) && hasAll) setIsCheckAll("checked");
        else setIsCheckAll("");
    };

    console.log(isChecks);

    useEffect(() => {
        handleOnCheckAll();
    }, [isChecks]);
    const headCells = [
        {
            id: "id_employee",
            disablePadding: false,
            label: "CHECKBOX",
            align: "end",
            // disabled: view
            values: [],
            indeterminate: isCheckAll === "indeterminate" && true,
            checked: isCheckAll === "checked" && true,
            disableDropdown: true,
            hiddenDropdown: true,
            onCheckAll: (event: any) => onCheckAll(event.target),
            width: 50,
            sortable: false,
        },
        {
            id: "leave_type_name",
            width: '350px',
            sortable: false,
            disablePadding: false,
            align: "start",
            label: t("MEETING.STAFF_ID"),
        },
        {
            id: "leave_type_name",
            width: '350px',
            sortable: false,
            disablePadding: false,
            align: "start",
            label: t("MEETING.FULL_NAME"),
        },
        {
            id: "leave_type_name",
            width: '250px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: t("MEETING.JOB_TITLE"),
        },

        {
            id: "user_updated",
            disablePadding: false,
            align: "center",
            width: '250px',
            label: t("MEETING.PERSONAL_DATA_PUBLICATION"),
        },
        {
            id: "last_updated",
            disablePadding: false,
            align: "center",
            width: '250px',
            label: t("MEETING.PROFILE_PICTURE_PUBLICATION"),
        },

        {
            id: "action",
            disablePadding: false,
            align: "center",
            width: '200px',
            label: "action",
        },
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1;
        const { id_employee, idcard, fullname, position_name, first_name, position, last_name, is_publish_profile, is_publish_profile_pic } =
            objData;
        const rowCheck = _.some(
            isChecks,
            (i: number) => Number(i) === Number(id_employee)
        );
        const objRenderData = {
            key: id_employee,
            id: no,
            obj: objData,
            rowSelect: rowCheck,
            columns: [
                {
                    option: "CHECKBOX",
                    align: "center",
                    label: id_employee,
                },
                {
                    option: "TEXT",
                    align: "start",
                    label: idcard,
                },
                {
                    option: "TEXT",
                    align: "start",
                    label: fullname || `${first_name} ${last_name}`,
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: position_name || position,
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: (
                        <div className="w-full justify-center ">
                            <SwitchCustom
                                checked={is_publish_profile || ''}
                                onChange={(value: boolean) => {
                                    //   handleSubmit(id_leave_type, value ? "active" : "inactive");
                                    setData((pre: any) => pre?.map((item: any, index: any) => {
                                        return index === no - 1 ? {
                                            ...item,
                                            is_publish_profile: value
                                        } : item
                                    }))
                                }}

                            />
                        </div>
                    ),
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: (
                        <div className="w-full justify-center ">
                            <SwitchCustom
                                checked={is_publish_profile_pic || ''}
                                onChange={(value: boolean) => {
                                    //   handleSubmit(id_leave_type, value ? "active" : "inactive");
                                    setData((pre: any) => pre?.map((item: any, index: any) => {
                                        return index === no - 1 ? {
                                            ...item,
                                            is_publish_profile_pic: value
                                        } : item
                                    }))
                                }}
                            />
                        </div>
                    ),
                },

                {
                    option: "TEXT",
                    align: "center",
                    label: (
                        <RemoveRedEyeOutlined
                            onClick={() => {
                                setDetail(objData)
                                setOpen(true)
                            }}
                            style={{
                                cursor: "pointer",
                            }}
                        />
                    ),
                },
            ],
        };
        return <TableRowCommon {...objRenderData} onCheck={(event) => onCheck(event.target)} />;
    };

    const fetchGetPositions = async () => {
        const param = {
            limit: 100,
        };
        const res = await PositionApi.list(param);
        const data = res.data;
        if (data.status < 300 && data.data && data.data?.items.length > 0) {
            setDataPosition(data.data.items);
        } else {
            setDataPosition([]);
        }
    };

    const fetchGetDepartments = async () => {
        const param = {
            keyword: "",
            limit: 100,
        };
        const res = await OrganizationApi.list(param);
        const data = res.data;
        if (data.status < 300 && data.data) {
            setDataDepartment(data.data);
        } else {
            setDataDepartment([]);
        }
    };

    useEffect(() => {
        fetchGetPositions();
        fetchGetDepartments();
    }, []);

    const getMeetingPosition = async () => {
        let condition: any = {
            page: 1,
            pageLimit: 100,
            status: 'active'
        };

        const res = await MeetingPositionApi.list(condition);
        const data = res.data
        if (data?.status < 300) {
            setMeetingPosition(data?.data.items);
            setPage(data?.data?.meta.currentPage)
            setTotalItems(data?.data?.meta?.totalItems)

        } else {
        }
    }


    const getDetail = async () => {
        await MeetingRoomApi.getParticipant(id, id_participant).then((res: any) => {
            if (res.status < 300) {
                setStep('GUEST')
                setFile(res.data.data?.meeting_participants_file)
                setContent({ ...res.data.data, is_publish_profile: res.data.data.is_publish_profile === 'active' ? true : false, is_publish_profile_pic: res.data.data.is_publish_profile_pic === 'active' ? true : false })
                // if (res.data.data.meeting_participants_type === 'EMPLOYEE') {
                //     setIsChecks([res.data.data.id_employee])
                //     setData([{...res.data.data, is_publish_profile: res.data.data.is_publish_profile === 'active' ? true : false, is_publish_profile_pic: res.data.data.is_publish_profile_pic === 'active' ? true : false}])
                // } else {
                setForm(res.data.data)
                // }

            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || t('เกิดข้อผิดพลาด'))
        })
    }

    const loadData = useCallback(async () => {
        // dispatch(setLoading());

        try {
            let condition: any = {};
            if (page) condition = { ...condition, page: page };
            if (pageLimit) condition = { ...condition, limit: pageLimit };
            if (search) condition = { ...condition, search: search };
            if (position !== 'ALL') condition = { ...condition, position: position };
            if (department !== 'ALL') condition = { ...condition, department: department };
            const res = await EmployeeApi.list(condition);
            const data = res.data
            if (data?.status < 300) {
                setData(data?.data.items);
                setPage(data?.data?.meta.currentPage)
                setTotalItems(data?.data?.meta?.totalItems)
                // dispatch(unsetLoading());
            } else {
                // dispatch(unsetLoading());
            }
        } catch (error) {
            // dispatch(unsetLoading());
        }
    }, [page, pageLimit, search, position, department]);

    useEffect(() => {
        if (!id_participant) {

            loadData();
        }
    }, [loadData]);
    useEffect(() => {
        getMeetingPosition()
        if (id_participant) {
            getDetail()
        }

    }, [])

    const handleSubmit = async () => {
        if (id_participant) {

            const body = {
                id_employee: undefined,
                title: form?.title || '',
                first_name: form?.first_name || '',
                last_name: form?.last_name || '',
                buddhist_name: form?.buddhist_name || '',
                title_eng: form?.title_eng || '',
                first_name_eng: form?.first_name_eng || '',
                last_name_eng: form?.last_name_eng || '',
                buddhist_name_eng: form?.buddhist_name_eng || '',
                tel: form?.tel || '',
                email: form?.email || '',
                position: form?.position || '',
                department: form?.department || '',
                // meeting_participants_type: step,
                meeting_participants_notification: content?.meeting_participants_notification ? 'active' : 'inactive',
                id_meeting_position: content?.id_meeting_position,
                meeting_participants_position: content?.meeting_participants_position,
                is_publish_profile: content?.is_publish_profile ? 'active' : 'inactive',
                is_publish_profile_pic: content?.is_publish_profile_pic ? 'active' : 'inactive',
                id_meeting_participants_file: file?.id_meeting_participants_file
            }
            await MeetingRoomApi.patchParticipants(body, id, id_participant).then((res: any) => {
                if (res.status < 300) {
                    swalSuccess(t('MEETING.ADD_MEETING_PARTICIPANT_SUCCESS'))
                    // loadData()
                    // handleClose()
                    navigate(routeName.cms.MeetingCaledarDetail.replace(':id', `${id}`));
                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || t('เกิดข้อผิดพลาด'))
            })
        } else {
            const body = {
                participants: step === 'EMPLOYEE' ? isChecks?.map((item: any) => {
                    return {
                        id_employee: item,
                        title: data?.find((x: any) => x?.id_employee === item)?.title || '',
                        first_name: data?.find((x: any) => x?.id_employee === item)?.first_name || '',
                        last_name: data?.find((x: any) => x?.id_employee === item)?.last_name || '',
                        buddhist_name: data?.find((x: any) => x?.id_employee === item)?.buddhist_name || '',
                        title_eng: data?.find((x: any) => x?.id_employee === item)?.title_eng || '',
                        first_name_eng: data?.find((x: any) => x?.id_employee === item)?.first_name_eng || '',
                        last_name_eng: data?.find((x: any) => x?.id_employee === item)?.last_name_eng || '',
                        buddhist_name_eng: data?.find((x: any) => x?.id_employee === item)?.buddhist_name_eng || '',
                        tel: data?.find((x: any) => x?.id_employee === item)?.tel || '',
                        email: data?.find((x: any) => x?.id_employee === item)?.email || '',
                        position: data?.find((x: any) => x?.id_employee === item)?.position_name || '',
                        department: data?.find((x: any) => x?.id_employee === item)?.department || '',
                        meeting_participants_type: step,
                        meeting_participants_notification: content?.meeting_participants_notification ? 'active' : 'inactive',
                        id_meeting_position: content?.id_meeting_position,
                        meeting_participants_position: content?.meeting_participants_position,
                        is_publish_profile: content?.is_publish_profile ? 'active' : 'inactive',
                        is_publish_profile_pic: content?.is_publish_profile_pic ? 'active' : 'inactive',
                        id_meeting_participants_file: 0
                    }
                }) : [
                    {
                        id_employee: undefined,
                        title: form?.title || '',
                        first_name: form?.first_name || '',
                        last_name: form?.last_name || '',
                        buddhist_name: form?.buddhist_name || '',
                        title_eng: form?.title_eng || '',
                        first_name_eng: form?.first_name_eng || '',
                        last_name_eng: form?.last_name_eng || '',
                        buddhist_name_eng: form?.buddhist_name_eng || '',
                        tel: form?.tel || '',
                        email: form?.email || '',
                        position: form?.position || '',
                        department: form?.department || '',
                        meeting_participants_type: step,
                        meeting_participants_notification: content?.meeting_participants_notification ? 'active' : 'inactive',
                        id_meeting_position: content?.id_meeting_position,
                        meeting_participants_position: content?.meeting_participants_position,
                        is_publish_profile: content?.is_publish_profile ? 'active' : 'inactive',
                        is_publish_profile_pic: content?.is_publish_profile_pic ? 'active' : 'inactive',
                        id_meeting_participants_file: file?.id_meeting_participants_file
                    }
                ]
            }
            await MeetingRoomApi.postParticipants(body, id).then((res: any) => {
                if (res.status < 300) {
                    swalSuccess(t('MEETING.ADD_MEETING_PARTICIPANT_SUCCESS'))
                    // loadData()
                    // handleClose()
                    navigate(routeName.cms.MeetingCaledarDetail.replace(':id', `${id}`));
                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || t('เกิดข้อผิดพลาด'))
            })
        }





    }
    const handleUpdate = async (file: any) => {

        const formData = new FormData();

        //DRAFT
        formData.append('file', file[0]);
        await MeetingRoomApi.uploadMeetingParticipantFile(formData, id).then((res: any) => {
            if (res.status < 300) {
                console.log(res.data);
                setFile(res.data)
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || t('เกิดข้อผิดพลาด'))
        })

    }
    return (
        <div className="h-auto">
            {/* breadcrumbs */}
            <NavigateListCustom
                navigateData={[
                    {
                        name: t("MEETING.MEETING_CALENDAR"),
                        key: "1",
                        pathName: routeName.cms.MeetingCalendar,
                    },
                    {
                        name: t("MEETING.ADD_MEETING"),
                        key: "2",
                        pathName: routeName.cms.MeetingCaledarCreate,
                    },
                    {
                        name: id_participant ? t('ข้อมูลผู้เข้าร่วมการประชุม') : t("MEETING.ADD_MEETING_PARTICIPANT"),
                        key: "3",
                        pathName: routeName.cms.MeetingCaledarCreate,
                    },
                ]}
            />
            <section className="my-4">
                <Typography variant="h3">{id_participant ? t('ข้อมูลผู้เข้าร่วมการประชุม') : t('MEETING.ADD_MEETING_PARTICIPANT')}</Typography>
            </section>
            <section className="w-full mt-10 flex flex-col gap-4 ">

                {!id_participant && <RadioCustom
                    // disabled={disable || !isCanEdit}
                    heading={t('MEETING.PERSON_TYPE')}
                    row
                    value={step || ''}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        setStep(e.target.value)
                        setContent({ ...content, meeting_participants_type: e.target.value })
                        //   handleChange(section, name, e.target.value);
                        //   handleChange(section, "detail", "");
                        //   handleChange(section, "sub_detail", "");
                    }}
                    dataList={[
                        {
                            label: t("MEETING.EMPLOYEE"),
                            value: "EMPLOYEE",

                        },
                        {
                            label: t("MEETING.GUEST"),
                            value: "GUEST",

                        },
                    ]}
                />}
                <CheckBoxCustom
                    checked={content?.meeting_participants_notification || ''}
                    label={t('MEETING.CREATE_INVITATION_CARD')}
                    setChecked={(status: boolean) => {
                        setContent({ ...content, meeting_participants_notification: status })
                    }
                    }
                    disabled={mode ? true : false}

                />
                <div>
                    <FilterSelect
                        heading={t('MEETING.MEETING_POSITION')}
                        value={content?.id_meeting_position || ''}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            // handleChange(section, name, e.target.value);
                            setContent({ ...content, id_meeting_position: e.target.value, meeting_participants_position: meetingPosition?.find((x) => x?.id_meeting_position === e.target?.value)?.meeting_position_name })
                        }}

                        options={meetingPosition?.map((option: any) => (
                            <MenuItem value={option.id_meeting_position} key={option.id_meeting_position}>
                                {option.meeting_position_name}
                            </MenuItem>
                        ))}
                        labelId={""}
                        selectId={""}
                        disabled={mode ? true : false}
                    />
                </div>
                <div className='border-2 border-dashed my-2 w-full'>

                </div>
                {step === 'EMPLOYEE' &&
                    <section className="w-full">
                        <div style={{ display: 'flex', gap: '20px' }}>
                            <SwitchCustom
                                checked={content?.is_publish_profile || ''}
                                onChange={(value: boolean) => {
                                    //   handleSubmit(id_leave_type, value ? "active" : "inactive");
                                    setContent({ ...content, is_publish_profile: value })
                                    setData((pre: any) => pre?.map((item: any) => {
                                        return {
                                            ...item,
                                            is_publish_profile: value
                                        }
                                    }))
                                }}
                                label={t('MEETING.PERSONAL_DATA_PUBLICATION')}
                            />
                            <SwitchCustom
                                checked={content?.is_publish_profile_pic || ''}
                                onChange={(value: boolean) => {
                                    //   handleSubmit(id_leave_type, value ? "active" : "inactive");
                                    setContent({ ...content, is_publish_profile_pic: value })
                                    setData((pre: any) => pre?.map((item: any) => {
                                        return {
                                            ...item,
                                            is_publish_profile_pic: value
                                        }
                                    }))
                                }}
                                label={t('MEETING.PROFILE_PICTURE_PUBLICATION')}
                            />
                        </div>

                        <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">

                            <article className="w-full col-span-12 md:col-span-4 lg:col-span-4 sm:col-span-12">
                                <InputTextField
                                    startAdornment={<SearchOutlined />}
                                    placeholder={t("ค้นหา")}
                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        setSearch(e.target.value)
                                    }}
                                    value={search}
                                />

                            </article>

                            <article className="w-full col-span-12 md:col-span-4 lg:col-span-4 sm:col-span-12">

                                <FilterSelect
                                    value={position ?? ""}
                                    // renderValue={() => "ทุกหลักสูตร"}
                                    labelId="position-id"
                                    selectId="position-select-id"
                                    options={[
                                        {
                                            id_position: "ALL",
                                            position_name: t("ทุกตำแหน่งงาน"),
                                        },
                                        ...dataPosition,
                                    ].map((list, index) => (
                                        <MenuItem value={list.id_position} key={index + 1}>
                                            {list.position_name}
                                        </MenuItem>
                                    ))}
                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                        setPosition(e.target.value)
                                    }
                                />
                            </article>

                            <article className="w-full col-span-12 md:col-span-4 lg:col-span-4 sm:col-span-12">

                                <FilterSelect
                                    value={department ?? ""}
                                    // renderValue={() => "ทุกสถานะ"}
                                    labelId="department-id"
                                    selectId="department-select-id"
                                    options={[
                                        {
                                            id_department: "ALL",
                                            department_name_th: t("ทุกหน่วยงาน"),
                                        },
                                        ...dataDepartment,
                                    ].map((list, index) => (
                                        <MenuItem value={list.id_department} key={index + 1}>
                                            {i18n.language === "en" ? ((list as any).department_name_eng || list.department_name_th) : list.department_name_th}
                                        </MenuItem>
                                    ))}
                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                        setDepartment(e.target.value)
                                    }
                                />
                            </article>


                        </div>

                        <section className="w-full mt-10">
                            <TableCustom
                                tableMinWidth={1440}
                                tableFixedWidth
                                customScroll
                                page={page}
                                pageLimit={pageLimit}
                                sortBy={sortBy}
                                sortType={sortType}
                                headCells={headCells}
                                rowCount={totalItems}
                                rowsData={
                                    data.map((data: any, i: any) => {
                                        return renderData(data, i);
                                    })
                                }
                                onSort={handleRequestSort}
                                setPageLimit={(value: number) => setPageLimit(value)}
                                setPage={(value: number) => setPage(value)}
                            />
                        </section>
                    </section>}
                {step === 'GUEST' &&
                    <section className="w-full mt-10">
                        <div>
                            <UploadAvatar
                                filePath={file ? file?.file_path + file?.file_name : undefined}
                                onDrop={(data) => handleUpdate(data)}
                                file={file}
                                hiddenDeleteButton
                                // helperText={t(errorMessage?.profile)}
                                // noClick={disabled}
                                onDelete={() => {
                                    // if (profileImage) {
                                    //     handleChangeFormPersonalRecord('profile', null);
                                    //     handleChangeFormPersonalRecord('is_profile', false);
                                    //     setProfileImage(null);
                                    // } else {
                                    //     handleChangeFormPersonalRecord('profile', null)
                                    // }
                                }}
                            />
                            <SwitchCustom
                                checked={content?.is_publish_profile_pic || ''}
                                onChange={(value: boolean) => {
                                    //   handleSubmit(id_leave_type, value ? "active" : "inactive");
                                    setContent({ ...content, is_publish_profile_pic: value })
                                }}
                                label={t('MEETING.PROFILE_PICTURE_PUBLICATION')}
                                disabled={mode ? true : false}
                            />
                            <div style={{ display: 'flex', gap: '20px' }}>
                                <Typography variant='h3'>{t('MEETING.PERSONAL_INFO')}</Typography>
                                <SwitchCustom
                                    checked={content?.is_publish_profile || ''}
                                    onChange={(value: boolean) => {
                                        //   handleSubmit(id_leave_type, value ? "active" : "inactive");
                                        setContent({ ...content, is_publish_profile: value })
                                    }}
                                    label={t('MEETING.PERSONAL_DATA_PUBLICATION')}
                                    disabled={mode ? true : false}
                                />
                            </div>

                        </div>
                        <Grid container spacing={2}>
                            <Grid
                                item
                                xs={12}
                                md={12}
                                lg={2}
                                sx={{
                                    alignSelf: "end",
                                }}
                            >
                                <FilterSelect
                                    // value={inputValueSearch.year ?? ""}
                                    heading={t('MEETING.TITLE_TH')}
                                    labelId="year-id"
                                    selectId="year-select-id"
                                    options={['นาย', 'นาง'].map((item: any, index: number) => ( // i18n-ignore: Thai title value stored as-is, label rendered with t
                                        <MenuItem value={item} key={index + 1}>
                                            {t(item)}
                                        </MenuItem>
                                    ))}
                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        setForm({ ...form, title: e.target.value })
                                    }}
                                    value={form?.title || ''}
                                    disabled={mode ? true : false || form?.meeting_participants_type === 'EMPLOYEE'}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                md={12}
                                lg={4}
                                sx={{
                                    alignSelf: "end",
                                }}
                            >
                                <InputTextField
                                    heading={t('MEETING.FIRST_NAME_TH')}
                                    placeholder={t('MEETING.FIRST_NAME_TH')}
                                    value={form?.first_name}
                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        // setFormMeetingRoom({ ...formMeetingRoom, meeting_room_name: e.target.value })
                                        setForm({ ...form, first_name: e.target.value })
                                    }
                                    }
                                    helperText={
                                        ""
                                    }
                                    disabled={mode ? true : false || form?.meeting_participants_type === 'EMPLOYEE'}

                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                md={12}
                                lg={3}
                                sx={{
                                    alignSelf: "end",
                                }}
                            >
                                <InputTextField
                                    heading={t('MEETING.LAST_NAME_TH')}
                                    placeholder={t('MEETING.LAST_NAME_TH')}
                                    value={form?.last_name}
                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        setForm({ ...form, last_name: e.target.value })
                                    }
                                    }
                                    helperText={
                                        ""
                                    }
                                    disabled={mode ? true : false || form?.meeting_participants_type === 'EMPLOYEE'}

                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                md={12}
                                lg={3}
                                sx={{
                                    alignSelf: "end",
                                }}
                            >
                                <InputTextField
                                    heading={t('MEETING.RELIGION_TH')}
                                    placeholder={t('MEETING.RELIGION_TH')}
                                    value={form?.buddhist_name}
                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        // setFormMeetingRoom({ ...formMeetingRoom, meeting_room_name: e.target.value })
                                        setForm({ ...form, buddhist_name: e.target.value })
                                    }
                                    }
                                    helperText={
                                        ""
                                    }
                                    disabled={mode ? true : false || form?.meeting_participants_type === 'EMPLOYEE'}

                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                md={12}
                                lg={2}
                                sx={{
                                    alignSelf: "end",
                                }}
                            >
                                <FilterSelect
                                    // value={inputValueSearch.year ?? ""}
                                    heading={t('MEETING.TITLE_EN')}
                                    labelId="year-id"
                                    selectId="year-select-id"
                                    options={['Mr.', 'Ms.'].map((item: any, index: number) => (
                                        <MenuItem value={item} key={index + 1}>
                                            {item}
                                        </MenuItem>
                                    ))}
                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        // setFormMeetingRoom({ ...formMeetingRoom, id_meeting_type: e.target.value })
                                        setForm({ ...form, title_eng: e.target.value })
                                    }}
                                    value={form?.title_eng || ''}
                                    disabled={mode ? true : false || form?.meeting_participants_type === 'EMPLOYEE'}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                md={12}
                                lg={4}
                                sx={{
                                    alignSelf: "end",
                                }}
                            >
                                <InputTextField
                                    heading={t('MEETING.FIRST_NAME_EN')}
                                    placeholder={t('MEETING.FIRST_NAME_EN')}
                                    value={form?.first_name_eng}
                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        // setFormMeetingRoom({ ...formMeetingRoom, meeting_room_name: e.target.value })
                                        setForm({ ...form, first_name_eng: e.target.value })
                                    }
                                    }
                                    helperText={
                                        ""
                                    }
                                    disabled={mode ? true : false || form?.meeting_participants_type === 'EMPLOYEE'}

                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                md={12}
                                lg={3}
                                sx={{
                                    alignSelf: "end",
                                }}
                            >
                                <InputTextField
                                    heading={t('MEETING.LAST_NAME_EN')}
                                    placeholder={t('MEETING.LAST_NAME_EN')}
                                    value={form?.last_name_eng}
                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        // setFormMeetingRoom({ ...formMeetingRoom, meeting_room_name: e.target.value })
                                        setForm({ ...form, last_name_eng: e.target.value })
                                    }
                                    }
                                    helperText={
                                        ""
                                    }
                                    disabled={mode ? true : false || form?.meeting_participants_type === 'EMPLOYEE'}

                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                md={12}
                                lg={3}
                                sx={{
                                    alignSelf: "end",
                                }}
                            >
                                <InputTextField
                                    heading={t('MEETING.RELIGION_EN')}
                                    placeholder={t('MEETING.RELIGION_EN')}
                                    value={form?.buddhist_name_eng}
                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        // setFormMeetingRoom({ ...formMeetingRoom, meeting_room_name: e.target.value })
                                        setForm({ ...form, buddhist_name_eng: e.target.value })
                                    }
                                    }
                                    helperText={
                                        ""
                                    }
                                    disabled={mode ? true : false || form?.meeting_participants_type === 'EMPLOYEE'}

                                />
                            </Grid>

                            <Grid
                                item
                                xs={12}
                                md={12}
                                lg={3}
                                sx={{
                                    alignSelf: "end",
                                }}
                            >
                                <InputTextField
                                    heading={t('MEETING.PHONE_NUMBER')}
                                    placeholder={t('MEETING.PHONE_NUMBER')}
                                    value={form?.tel}
                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        // setFormMeetingRoom({ ...formMeetingRoom, meeting_room_name: e.target.value })
                                        setForm({ ...form, tel: e.target.value })
                                    }
                                    }
                                    helperText={
                                        ""
                                    }
                                    disabled={mode ? true : false || form?.meeting_participants_type === 'EMPLOYEE'}

                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                md={12}
                                lg={3}
                                sx={{
                                    alignSelf: "end",
                                }}
                            >
                                <InputTextField
                                    heading={t('MEETING.EMAIL')}
                                    placeholder={t('MEETING.EMAIL')}
                                    value={form?.email}
                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        // setFormMeetingRoom({ ...formMeetingRoom, meeting_room_name: e.target.value })
                                        setForm({ ...form, email: e.target.value })
                                    }
                                    }
                                    helperText={
                                        ""
                                    }
                                    disabled={mode ? true : false || form?.meeting_participants_type === 'EMPLOYEE'}

                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                md={12}
                                lg={3}
                                sx={{
                                    alignSelf: "end",
                                }}
                            >
                                <InputTextField
                                    heading={t('MEETING.CURRENT_JOB_TITLE')}
                                    placeholder={t('MEETING.CURRENT_JOB_TITLE')}
                                    value={form?.position}
                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        // setFormMeetingRoom({ ...formMeetingRoom, meeting_room_name: e.target.value })
                                        setForm({ ...form, position: e.target.value })
                                    }
                                    }
                                    helperText={
                                        ""
                                    }
                                    disabled={mode ? true : false || form?.meeting_participants_type === 'EMPLOYEE'}

                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                md={12}
                                lg={3}
                                sx={{
                                    alignSelf: "end",
                                }}
                            >
                                <InputTextField
                                    heading={t('MEETING.DEPARTMENT')}
                                    placeholder={t('MEETING.DEPARTMENT')}
                                    value={form?.department}
                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        // setFormMeetingRoom({ ...formMeetingRoom, meeting_room_name: e.target.value })
                                        setForm({ ...form, department: e.target.value })
                                    }
                                    }
                                    helperText={
                                        ""
                                    }
                                    disabled={form?.meeting_participants_type === 'EMPLOYEE'}

                                />
                            </Grid>

                        </Grid>


                    </section>}

                <section className="col-span-12 flex items-center justify-center gap-4 my-4">
                    <ButtonOutlined
                        onClick={() => {
                            navigate(-1);
                        }}
                        buttonName={t("ย้อนกลับ")}
                        btnProps={{
                            width: "150px",
                        }}
                    />

                    {!mode && <ButtonPrimary
                        onClick={() => {
                            // handleSubmit(inputValueFormStudent.information);
                            handleSubmit()
                        }}
                        buttonName={t("ยืนยัน")}
                        btnProps={{
                            width: "150px",
                        }}
                    />}

                </section>
            </section>
            <ModalCustom maxWidth={1000} title={t('MEETING.PERSONAL_INFO')} subTitle={t('กรุณาเลือกรายการที่ท่านต้องการ')} open={open} component={
                <div>
                    <Typography variant='h6'>{t('MEETING.PERSONAL_INFO')}</Typography>
                    <Grid container spacing={2}>

                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={3}
                            sx={{
                                alignSelf: "end",
                            }}
                        >

                            <InputTextField
                                heading={t('MEETING.TITLE_TH')}
                                placeholder={''}
                                value={detail?.title || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                }
                                }
                                helperText={
                                    ""
                                }
                                disabled
                            />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={3}
                            sx={{
                                alignSelf: "end",
                            }}
                        >

                            <InputTextField
                                heading={t('MEETING.FIRST_NAME_TH')}
                                placeholder={''}
                                value={detail?.first_name || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                }
                                }
                                helperText={
                                    ""
                                }
                                disabled
                            />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={3}
                            sx={{
                                alignSelf: "end",
                            }}
                        >

                            <InputTextField
                                heading={t('MEETING.LAST_NAME_TH')}
                                placeholder={''}
                                value={detail?.last_name || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                }}
                                helperText={
                                    ""
                                }
                                disabled
                            />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={3}
                            sx={{
                                alignSelf: "end",
                            }}
                        >

                            <InputTextField
                                heading={t('MEETING.NICKNAME_TH')}
                                placeholder={''}
                                value={detail?.password || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                }
                                }
                                helperText={
                                    ""
                                }
                                disabled
                            />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={3}
                            sx={{
                                alignSelf: "end",
                            }}
                        >

                            <InputTextField
                                heading={t('MEETING.TITLE_EN')}
                                placeholder={''}
                                value={detail?.title_eng || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                }
                                }
                                helperText={
                                    ""
                                }
                                disabled
                            />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={3}
                            sx={{
                                alignSelf: "end",
                            }}
                        >

                            <InputTextField
                                heading={t('MEETING.FIRST_NAME_EN')}
                                placeholder={''}
                                value={detail?.first_name_eng || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                }
                                }
                                helperText={
                                    ""
                                }
                                disabled
                            />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={3}
                            sx={{
                                alignSelf: "end",
                            }}
                        >

                            <InputTextField
                                heading={t('MEETING.LAST_NAME_EN')}
                                placeholder={''}
                                value={detail?.last_name_eng || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                }
                                }
                                helperText={
                                    ""
                                }
                                disabled
                            />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={3}
                            sx={{
                                alignSelf: "end",
                            }}
                        >

                            <InputTextField
                                heading={t('MEETING.NICKNAME_EN')}
                                placeholder={''}
                                value={detail?.password || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                }
                                }
                                helperText={
                                    ""
                                }
                                disabled
                            />
                        </Grid>

                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={3}
                            sx={{
                                alignSelf: "end",
                            }}
                        >

                            <InputTextField
                                heading={t('MEETING.STAFF_ID')}
                                placeholder={''}
                                value={detail?.idcard || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                }
                                }
                                helperText={
                                    ""
                                }
                                disabled
                            />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={3}
                            sx={{
                                alignSelf: "end",
                            }}
                        >

                            <InputTextField
                                heading={t('MEETING.PHONE_NUMBER')}
                                placeholder={''}
                                value={detail?.tel || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                }
                                }
                                helperText={
                                    ""
                                }
                                disabled
                            />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={3}
                            sx={{
                                alignSelf: "end",
                            }}
                        >

                            <InputTextField
                                heading={t('MEETING.PERSONAL_EMAIL')}
                                placeholder={''}
                                value={detail?.email || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                }
                                }
                                helperText={
                                    ""
                                }
                                disabled
                            />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={3}
                            sx={{
                                alignSelf: "end",
                            }}
                        >

                            <InputTextField
                                heading={t('MEETING.ORGANIZATION_EMAIL')}
                                placeholder={''}
                                value={detail?.email || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                }
                                }
                                helperText={
                                    ""
                                }
                                disabled
                            />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={3}
                            sx={{
                                alignSelf: "end",
                            }}
                        >

                            <InputTextField
                                heading={t('MEETING.GENDER')}
                                placeholder={''}
                                value={detail?.gender || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                }
                                }
                                helperText={
                                    ""
                                }
                                disabled
                            />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={3}
                            sx={{
                                alignSelf: "end",
                            }}
                        >

                            <InputTextField
                                heading={t('MEETING.CURRENT_JOB_TITLE')}
                                placeholder={''}
                                value={detail?.position_name || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                }
                                }
                                helperText={
                                    ""
                                }
                                disabled
                            />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={3}
                            sx={{
                                alignSelf: "end",
                            }}
                        >

                            <InputTextField
                                heading={t('MEETING.JOB_LEVEL')}
                                placeholder={''}
                                value={''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                }
                                }
                                helperText={
                                    ""
                                }
                                disabled
                            />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={3}
                            sx={{
                                alignSelf: "end",
                            }}
                        >

                            <InputTextField
                                heading={t('MEETING.WORK_PHONE')}
                                placeholder={''}
                                value={''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                }
                                }
                                helperText={
                                    ""
                                }
                                disabled
                            />
                        </Grid>


                    </Grid>
                    <div className='flex justify-center gap-4 mt-4'>
                        <ButtonBack
                            onClick={() => {
                                setOpen(false)
                                setForm(null)

                            }}
                            buttonName={t('ปิด')}
                        />

                    </div>
                </div>
            } />
        </div>
    )
}
